<template>
  <static-fullscreen-card>
    <portal to="v-goup" v-if="idShow">
      <v-btn class="mr-3" fab small @click="$emit('close', data)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <template v-slot:title> ({{ data.id }}) {{ m.title + ` "${data.name}"` }}</template>
    <template v-slot:actions>
      <a-btn-edit v-if="accessEdit" @click="onEditGroup()" :disabled="!canEdit" />
      <a-btn-delete
        v-if="id && data.status === 0 && getAccess(`${accessName}.delete`, { users: [data.createdby_id] })"
        :disabled="!canDelete"
        @click="removeDialogShow = true"
      />
    </template>
    <v-row>
      <v-col cols="12" sm="6" class="px-2">
        <material-card color="secondary">
          <template v-slot:heading> </template>
          <a-form-view :value="data" :model="modelLeft" :config="{ dense: true, hideNull: false }" @click="onClick($event)" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6" class="px-2">
        <material-card color="secondary">
          <template v-slot:heading> </template>
          <a-form-view :value="data" :model="modelRight" :config="{ dense: true, hideNull: false }" :style1="{ height: blockHeight + 'px' }" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="12" class="px-2 pt-1">
        <material-card color="third" class="block_detail">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color="white">
              <v-tab v-for="(tab, i) in tabs" v-if="tab.show" :key="i" class="mr-3" :href="`#tab-${tab.name}`">
                {{ tab.title }}
              </v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px" touchless>
            <v-tab-item v-for="(t, i) in tabs" :key="i" v-if="t.show" :id="`tab-${t.name}`">
              <v-card-text v-if="t.name == 'statuses'" :style="styleDetailCard" class="pa-0">
                <a-table-f-api
                  ref="tableStatuses"
                  :api="m_statuses.api"
                  :model="m_statuses.list"
                  :searchable="false"
                  :defaults="{
                    filters: { leads_status_group_id: idShow },
                    sort: { key: 'id', order: 'DESC' },
                    paramName: 'leadGroupStatuses',
                  }"
                  @click="onDoubleClick($event, m_statuses)"
                  @loadData="statuses = $event"
                >
                  <template v-slot:top v-if="getAccess(`${accessName}.edit`, { users: [data.createdby_id] })">
                    <v-fab-transition>
                      <v-btn
                        fab
                        dark
                        color="green"
                        absolute
                        bottom
                        small
                        style="bottom: 15px"
                        left
                        class="v-btn--example"
                        @click="onCreateElement('statuses', m_statuses)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-fab-transition>
                  </template>
                </a-table-f-api>
              </v-card-text>
              <v-card-text v-if="t.name == 'tasks'" :style="styleDetailCard" class="pa-0">
                <a-table-f-api
                  ref="tableTasks"
                  :api="m_tasks.api"
                  :model="m_tasks.list"
                  :searchable="false"
                  :defaults="{
                    filters: { leads_status_group_id: idShow },
                    sort: { key: 'id', order: 'DESC' },
                    paramName: 'leadGroupTasks',
                  }"
                  @click="onDoubleClick($event, m_tasks)"
                  @loadData="tasks = $event"
                >
                  <template v-slot:top v-if="getAccess(`${accessName}.edit`, { users: [data.createdby_id] })">
                    <v-fab-transition>
                      <v-btn fab dark color="green" absolute bottom small style="bottom: 15px" left class="v-btn--example" @click="onCreateElement('tasks', m_tasks)">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-fab-transition>
                  </template>
                </a-table-f-api>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
    <div v-if="loading" class="loading-block">
      <div class="loader"></div>
    </div>
    <portal to="v-main">
      <s-edit-form
        v-model="showEditDialog"
        v-if="showEditDialog"
        :api="m_edit.api"
        :m="m_edit"
        :id="idEdit"
        :initData="initData"
        :configForm="{ type: 'default' }"
        :opt="{ closeAfterSave: !false, delete: !readonly, readonly, statuses, tasks, groups: $root.dirs.leadsGroup }"
      />
      <remove-dialog v-model="removeDialogShow" @remove="remove(api, id)" :title="removeTitle" />
    </portal>
    <confirm-dialog ref="confirmDialog" />
    <a-loader v-if="loading" />
  </static-fullscreen-card>
</template>

<script>
import "./../components";
import { autoHeightBlock, getAccess, removeEl, genModel } from "@/components/mixings";
export default {
  mixins: [autoHeightBlock, getAccess, removeEl, genModel],
  props: {
    idShow: Number,
    dirCurrent: Object,
    m: Object,
  },
  components: {},
  data() {
    return {
      id: 0,
      idEdit: 0,
      idDeleting: 0,
      initData: {},
      fieldsRO: [],
      suEditShow: false,
      showEditDialog: false,
      removeDialogShow: false,
      removeTitle: "Вы действительно хотите запись'?",
      loading: false,
      loaded: false,
      title: "",
      data: {},
      tab: 0,
      m_edit: {},
      tabList: [
        { name: "statuses", title: "Этапы", show: true },
        { name: "tasks", title: "Задачи", show: true },
      ],
      readonly: false,
      statusCur: null,
      tasks: [],
      statuses: [],
    };
  },
  created() {
    this.loading = true;
    this.$root.title = this.m.title;
    this.id = this.idShow || Number(this.$route.params.id);
    //    this.permit = this.getAccess("menu.objects");
    this.fitchData();
    this.loaded = true;
  },
  mounted() {},

  computed: {
    m_statuses() {
      console.log("models", this.$store.getters["config/get"].models);
      return this.getObjectPath(this.$store.getters["config/get"].models, "dir_leadsGroup.statuses");
    },
    m_tasks() {
      return this.getObjectPath(this.$store.getters["config/get"].models, "dir_leadsGroup.leads_task_template");
      return this.getObjectPath(this.$store.getters["config/get"].models, "dirs.leads_task_template");
    },
    tabs() {
      let res = [];
      res = this.tabList;
      return res;
    },
    api() {
      return this.dirCurrent.api;
    },
    url() {
      return this.dirCurrent.api;
    },
    accessName() {
      return this.m.accessName || "none";
    },
    accessEdit() {
      console.log("access edit ", this.accessName, this.getAccess(this.accessName + ".edit", { users: [this.data.createdby_id] }));
      return this.getAccess(this.accessName + ".edit", { users: [this.data.createdby_id] });
    },

    canEdit() {
      return true;
    },
    canDelete() {
      return true;
    },
    modelLeft() {
      let model = this.calcModel("viewForm1");
      return model;
    },
    modelRight() {
      let model = this.calcModel("viewForm2");
      return model;
    },
    model: {
      get() {
        let conf = JSON.parse(JSON.stringify(this.m?.config || {}));
        const f = conf.configField;
        let config;
        if (f) {
          config = conf.config.find((el) => {
            if (Array.isArray(el.value)) return el.value.includes(this.data[f]);
            return el.value == this.data[f];
          });
        }
        config = config || conf.default;
        // this.configHead = config;
        let model = this.calcModelConfig(config);
        return model;
      },
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.initData = {};
        this.fitchData();
      }
    },

    showAddDocDialog(v) {
      if (!v) {
        this.fitchData();
      }
    },
  },
  methods: {
    onDoubleClick(d, m) {
      this.initData = { leads_status_group_id: this.idShow };
      this.showEditDialogFun(d.row.id, m);
      return;
    },
    onCreateElement(t, m) {
      this.initData = { leads_status_group_id: this.idShow };
      this.showEditDialogFun(0, m);
    },
    onEditGroup() {
      this.initData = {};
      this.showEditDialogFun(this.id, this.m);
    },
    showEditDialogFun(id, m) {
      this.m_edit = m;
      this.idEdit = id;
      this.showEditDialog = true;
    },

    async fitchData() {
      this.loading = true;
      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
      }
      this.afterFetchData();
      const lead_group = this.$root.dirs?.leadsGroup;

      this.loading = false;
    },
    afterRemove(data) {
      this.removeDialogShow = false;
      if (this.idShow) this.$emit("close", this.data);
      else this.$router.push({ name: "videos" });
    },
    afterFetchData(r) {
      if (this.id) {
        //   this.calcModel();
      }
      this.loaded = true;
    },
  },
};
</script>
